import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'empresas/giros-comerciales/';

/**
 * GET Giros Comerciales
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getGirosComerciales = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Giro Comercial
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getGiroComercial = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Giro Comercial
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postGiroComercial = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Giro Comercial
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchGiroComercial = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Giro Comercial
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteGiroComercial = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
